define('commons/install-data-config',['jquery', 'commons/config-tree'], function($, ConfigTree) {
    // INSTALL DATA TREE
    var InstallDataConfig = function(args) {
        ConfigTree.apply(this, [args]);
        this.tree.fancytree(this.settings);
    };

    for ( var element in ConfigTree.prototype) {
        InstallDataConfig.prototype[element] = ConfigTree.prototype[element];
    }

    InstallDataConfig.prototype.checkStatus = function(childs) {
        var status = "";
        $.each(childs, function (section, value){
            if (value.id == 'status' && value.isTest){
                status = " hwtree-status-" + value.value; 
            }
        });
        return status;
    };

    InstallDataConfig.prototype.createTitle = function(data, id) {
        var cls = "hwtree-default-icon";
        if (typeof data.class !== 'undefined'){
            cls +=  " hwtree-" + data["class"] + "-icon";
        }
        if (typeof data.children !== 'undefined'){
            cls += this.checkStatus(data.children);
        }
        var title = '<span class="' + cls + '">';
        title += data.id;
        title += '</span>';
        return title;
    };

    InstallDataConfig.prototype.createNode = function(parent, data, id, title, selected) {
        var element = data.value;
        if (data.array){
            title = element;
        } else if (typeof data.value !== 'undefined'){
            title += ' : ' + element;
        }
        return parent.addChildren({
            title : title,
            icons: false,
            selected : true,
            field : data.id,
            value : data.value,
            array : data.array,
            key : id,
            active : selected
        });
    };

    InstallDataConfig.prototype.expandAll= function(){
        this.tree.fancytree("getRootNode").visit(function(node){
            node.setExpanded(true);
        });
    };

    InstallDataConfig.createFancyChilds = function(parent, data, isArray, onlyTest, parentIsTest) {
        var children = [];
        $.each(data, function (section, value){
            var isTest = parentIsTest || (!isArray && (section.toString().match("Test$") !== null || parent.toString().match("Test$") !== null)) || (!isArray && (section.toString().match("TestAfterSwitched$") !== null || parent.toString().match("TestAfterSwitched$") !== null)) || (!isArray && section.toString().match("status$")!== null);
            var process = (!onlyTest && !isTest) || (onlyTest && isTest);
            if (process){
                var node = {};
                if ($.isArray(value) || (typeof value === 'object')){
                    node.id = section;
                    var childs = InstallDataConfig.createFancyChilds(section, value, $.isArray(value), onlyTest, isTest);
                    if (childs.length > 0){
                        node.children = childs;
                    }
                } else {
                    node.array = isArray;
                    node.id = section;
                    node.value = value;
                }
                node.field = section;
                node.isTest = onlyTest;
                children.push(node);
            }
        });
        return children;
    };

    InstallDataConfig.toFancyFormat = function(data) {
        var json = {};
        var config = {};
        var tests = {};
        childrenConfig = [];
        childrenTests = [];
        $.each(data, function (section, value){
            var nodeConfig = {};
            nodeConfig.id = section;
            nodeConfig.class = section;
            nodeConfig.children = InstallDataConfig.createFancyChilds(section, value, false, false, false);
            childrenConfig.push(nodeConfig);
            var nodeTest = {};
            nodeTest.id = section;
            var childs = InstallDataConfig.createFancyChilds(section, value, false, true, false);
            if (childs.length > 0){
                nodeTest.children = childs;
                childrenTests.push(nodeTest);
            }
        });
        config.children = childrenConfig.sort(function(a, b){
            if (a.id.toLowerCase() < b.id.toLowerCase()){
                return -1;
            } else if (a.id.toLowerCase() > b.id.toLowerCase()){
                return 1;
            } else {
                return 0;
            }
        });
        tests.children = childrenTests.sort(function(a, b){
            if (a.id.toLowerCase() < b.id.toLowerCase()){
                return -1;
            } else if (a.id.toLowerCase() > b.id.toLowerCase()){
                return 1;
            } else {
                return 0;
            }
        });
        json.config = config;
        json.tests = tests;
        return json;
    };

    InstallDataConfig.getJsonChildren = function(jsonNode) {
        var children = {};
        var array = [];
        $.each(jsonNode.children, function (index, node){
            if (node.hasOwnProperty("children") && node.children.length !== 0){
                children[node.data.field] = InstallDataConfig.getJsonChildren(node);
            } else if (node.selected && node.data.hasOwnProperty("array") && node.data.array){
                array.push(node.data.value);
            } else if (node.selected) { 
                children[node.data.field] = node.data.value;
            }
        });
        return (array.length !==0 ? array : children);
    };

    InstallDataConfig.prototype.getJson = function(){
        var dict = this.tree.fancytree("getTree").toDict(false);
        var json = {};
        $.each(dict, function (index, node){
            if (node.children.length !== 0){
                json[node.data.field] = InstallDataConfig.getJsonChildren(node);
            }
        });
        // Remove empty element
        return InstallDataConfig.trimJson(json);
    };

    InstallDataConfig.trimJson = function(data){
        var y;
        for (var x in data) {
            y = data[x];
            if (y instanceof Object && Object.keys(y).length !== 0) {
                y = InstallDataConfig.trimJson(y);
            }
            if (y === "null" || y === null || y === "" || typeof y === "undefined" || (y instanceof Object && Object.keys(y).length === 0)) {
                delete data[x];
            }
        }
        return data;
    };
    return InstallDataConfig;
});
